<template>
  <div class="content">
    <el-row class="bgW">
      <el-col :span="22">
        <!--检索条件-->
        <el-form class="search" label-suffix="：" :inline="true" size="mini" :model="search">
          <!-- <el-form-item label="门店/门诊">
            <el-select
              v-model="search.shop_id"
              clearable
              remote
              filterable
              :remote-method="remoteMethod"
              placeholder="请输入"
              class="w120"
            >
              <el-option
                v-for="item in options.shop_id"
                :key="item.shopId"
                :label="item.shopName"
                :value="item.shopId"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="姓名">
            <el-input
              v-model="search.customer_name"
              maxlength="30"
              class="w84"
              placeholder="请输入"
              clearable
            />
          </el-form-item>
          <el-form-item label="手机号">
            <el-input
              v-model="search.telephone"
              maxlength="30"
              class="w84"
              placeholder="请输入"
              clearable
            />
          </el-form-item> -->
        </el-form>
      </el-col>
      <el-col :span="2" style="text-align: right;">
        <el-button type="primary" icon="el-icon-search" size="mini" @click="getList('search')">搜索</el-button>
      </el-col>
    </el-row>
    <div class="accountCon">
      <!--列表-->
      <el-row>
        <el-col :span="24">
          <el-table
            :data="list"
            size="small"
            border
            v-loading="loading"
            :cell-style="$style.cellStyle"
            :header-cell-style="$style.rowClass"
          >
            <el-table-column type="index" label="序号" width="50" align="center"/>
            <el-table-column label="客户姓名" prop="customer_name" />
            <el-table-column label="电话" prop="telephone"/>
            <el-table-column label="累计消耗本金" width="120" prop="consume_sum"/>
            <el-table-column label="归属门店" prop="shop_name"/>
            <el-table-column label="归属护理师" prop="person_name"/>
            <el-table-column label="首次到店时间" width="170" prop="first_service_time"/>
            <el-table-column label="末次到店时间" width="170" prop="last_service_time"/>
            <el-table-column label="预测下次到店时间" width="180" prop="appointment_time"/>
            <el-table-column label="预测间隔天数" width="110" prop="predicted_interval_days"/>
            <el-table-column label="顾客状态" prop="customer_status"/>
            <el-table-column label="预估距今天数" prop="day_diff"/>
          </el-table>
          <pagination
            class="page tc mt10"
            :total="page.total"
            :page.sync="page.page"
            :limit.sync="page.limit"
            @pagination="getList"
          />
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { getServiceList } from "@/api/client";
import pagination from "@/components/Pagination";
import { getShopList } from "@/api/shop";

class Search {
  shop_id = "";
  customer_name = "";
  telephone = "";
}
class Page {
  total = 0;
  page = 1;
  limit = 10;
}
class Options {
  shop_id = [];
}
export default {
  name: "PointList",
  components: {
    pagination
  },
  data() {
    return {
      search: new Search(),
      page: new Page(),
      options: new Options(),
      list: [],
      loading: false,
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList(option) {
      this.loading = true;
      if (option === "search") this.page = new Page();
      getServiceList({ ...this.search, page: this.page.page, limit: this.page.limit }).then(
        res => {
          this.list = res.list;
          this.page.total = res.dataCount;
          this.loading = false;
        }
      ).catch(()=>{
        this.loading = false;
      })
    },
    // 搜索门店
    remoteMethod(e) {
      getShopList({ page: 1, limit: 100000, shopName: e }).then(res => {
        this.options.shop_id = res.list;
      });
    },
  }
};
</script>

<style lang="scss" scoped>

</style>